import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { IMailReminderExecutorProps } from './IMailReminderExecutorProps';
import { MailReminderExecutorModal } from './MailReminderExecutorModal';

export class MailReminderExecutor extends DocBaseActionExecutor {
    private _modalProps?: IMailReminderExecutorProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            actionKey: action.key ?? '',
            title: action.options?.title ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            completeHandler: completeHandler,
            prefilledText: '',
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <MailReminderExecutorModal {...this._modalProps} /> : <div />;
    };
}
